<template>
    <div class="rule-list">
        <v-tip
            ref="apiCreate"
            placement="top"
        >
            {{ $t('此条规则可能由API创建，暂不支持展示监控对象') }}
        </v-tip>
        <v-table
            :data="ruleList"
            :loading="loading"
            @rowClick="rowClick"
        >
            <v-table-column
                :key="columnConfig.name.label"
                :column-key="columnConfig.name.columnKey"
                :label="$t(columnConfig.name.label)"
                :width="columnConfig.name.width"
                clazz="name-column"
            >
                <template
                    slot="cell"
                    slot-scope="props"
                >
                    <rule-name-cell :name="props.row.name" />
                </template>
            </v-table-column>
            <!-- <template v-if="currentTab !== 'client'">
                <v-table-column
                    :key="columnConfig.type.label"
                    :column-key="columnConfig.type.columnKey"
                    :label="columnConfig.type.label"
                    clazz="name-column"
                >
                    <template slot-scope="props" slot="cell">
                        {{ props.row.type }}
                    </template>
                </v-table-column>
            </template> -->
            <v-table-column
                :key="columnConfig.sensitiveWords.label"
                :column-key="columnConfig.sensitiveWords.columnKey"
                :label="$t(columnConfig.sensitiveWords.label)"
                :width="columnConfig.sensitiveWords.width"
            >
                <template
                    slot="cell"
                    slot-scope="props"
                >
                    <sensitive-words-cell :sensitive-words="props.row.wordList" @onTagClick="onTagClickHandler" />
                </template>
            </v-table-column>
            <template v-if="clientSideFlag === 1 && currentTab !== 'client'">
                <v-table-column
                    :key="columnConfig.monitorTypes.label"
                    :column-key="columnConfig.monitorTypes.columnKey"
                    :label="$t(columnConfig.monitorTypes.label)"
                    clazz="monitor-types-column"
                >
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <monitor-types-cell :monitor-types="props.row.channelIds" />
                    </template>
                </v-table-column>
            </template>
            <v-table-column
                :key="columnConfig.monitorInfoList.label"
                :column-key="columnConfig.monitorInfoList.columnKey"
                :label="$t(columnConfig.monitorInfoList.label)"
                :width="columnConfig.monitorInfoList.width"
            >
                <template
                    slot="cell"
                    slot-scope="props"
                >
                    <staff-list-cell
                        v-if="props.row"
                        :staff-list="props.row"
                    />
                    <span
                        v-else
                        v-tip:apiCreate.hover
                    >{{ $t('暂不支持显示') }}</span>
                </template>
            </v-table-column>
            <v-table-column
                :key="columnConfig.actionType.label"
                :column-key="columnConfig.actionType.columnKey"
                :label="$t(columnConfig.actionType.label)"
                clazz="action-type-column"
            >
                <template
                    slot="cell"
                    slot-scope="props"
                >
                    <div class="rule-list__actionType">
                        <!-- <v-icon :name="iconActionType(props.row.actionType)" /> -->
                        <span>{{ $t(textActionType(props.row.actionType)) }}</span>
                    </div>
                </template>
            </v-table-column>
            <v-table-column
                :key="columnConfig.isSwitchOn.label"
                :column-key="columnConfig.isSwitchOn.columnKey"
                :label="$t(columnConfig.isSwitchOn.label)"
                clazz="switch-on-column"
            >
                <template
                    slot="cell"
                    slot-scope="props"
                >
                    <div class="rule-list__isSwitchOn">
                        <v-switch
                            v-model="props.row.status"
                            @click="itemStatusClick(props.row)"
                        />
                    </div>
                </template>
            </v-table-column>
            <v-table-column
                :key="columnConfig.action.label"
                :column-key="columnConfig.action.columnKey"
                :label="$t(columnConfig.action.label)"
                clazz="action-column"
            >
                <template
                    slot="cell"
                    slot-scope="props"
                >
                    <div class="rule-list__action">
                        <v-tip
                            :disabled="props.row.hasRecord == 1"
                            ref="export"
                            placement="top"
                        >
                            <span>{{ $t('暂无记录,无法导出') }}</span>
                        </v-tip>
                        <v-button
                            type="link"
                            kind="primary"
                            class="action-btn"
                            @click.stop="editItem(props.row)"
                        >
                            {{ $t('编辑') }}
                        </v-button>
                        <v-button
                            type="link"
                            kind="primary"
                            class="action-btn"
                            @click.stop="calldelItemDialog(props.row)"
                        >
                            {{ $t('删除') }}
                        </v-button>
                        <v-button
                            v-tip:export
                            type="link"
                            kind="primary"
                            class="action-btn"
                            :disabled="props.row.hasRecord != 1"
                            @click.stop="download(props.row)"
                        >
                            {{ $t('导出') }}
                        </v-button>
                    </div>
                </template>
            </v-table-column>
        </v-table>
        <v-dialog
            v-model="delDialogShow"
            :title="$t('删除敏感词规则?')"
            kind="confirm"
            status="warning"
            @confirm="delItem"
        >
            <div>{{ $t('删除会使此敏感词规则失效。') }}</div>
            <span slot="confirm-text">{{ $t('删除') }}</span>
        </v-dialog>
    </div>
</template>

<script>
/* eslint-disable */

import { Icon } from 'vhtml-ui';
import ruleNameCell from '../rule-name-cell';
import sensitiveWordsCell from '../sensitive-words-cell';
import monitorTypesCell from '../monitor-types-cell';
import staffListCell from '../staff-list-cell';
import urlTool from '@/utils/urlTool';
import utils from '../../utils/utils';
import { envDomain } from 'src/utils/domainConfig';

const req = require.context('@/assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);
const columnConfig = {
    name: {
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '规则名',
        columnKey: 'name',
        width: 202
    },
    // type: {
    //     label: '敏感类型',
    //     columnKey: 'type',
    //     width: 202
    // },
    sensitiveWords: {
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '敏感词',
        columnKey: 'wordList',
        // formatter: function(value) {
        //   return new Date(value).toString().substr(0, 15);
        // },
        width: 282
    },
    monitorTypes: {
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '监控消息类型',
        columnKey: 'channelIds',
        width: 148
    },
    monitorInfoList: {
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '监控对象',
        columnKey: 'staffList',
        width: 236
    },
    actionType: {
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '告警程度',
        columnKey: 'actionType',
        width: 166
    },
    isSwitchOn: {
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '状态',
        columnKey: 'status',
        width: 107
    },
    action: {
        label: '',
        columnKey: 'action',
        // align: "right",
        width: 90
    }
};

const ACTION_TYPE_DEGREE = {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    4: '消息替换过滤为*',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    3: '仅留存记录',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    2: '提示但不拦截',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    1: '消息拦截'
};
const ACTION_TYPE_ICON = {
    4: 'attention_level3',
    3: 'attention_level1',
    2: 'attention_level2',
    1: 'attention_level3'
};
export default {
    name: 'RuleList',
    components: {
        sensitiveWordsCell,
        monitorTypesCell,
        staffListCell,
        ruleNameCell
    },
    props: {
        ruleList: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: true
        }
    },
    data() {
        let  clientSideFlag  =  0 ;
        if(window.data.data) {
            clientSideFlag  =  window.data.data.clientSideFlag ;
        }
        return {
            columnConfig,
            downloadHoverId: -1,
            delDialogShow: false,
            delId: -1,
            currentTab: urlTool.getUrlParameter("currentTab") || 'staff',
            clientSideFlag: parseInt(clientSideFlag,10)
        };
    },
    computed: {},
    watch: {},
    created() {
        let  currentColumnConfig = Object.assign({},this.columnConfig);
        if(this.clientSideFlag === 1 ) {
            if(this.currentTab === 'client') {
                // 客户敏感词没有类型
                delete currentColumnConfig.monitorTypes;
            }
        }
        this.columnConfig = currentColumnConfig;
    },
    methods: {
        rowClick() {},
        iconActionType(index) {
            return ACTION_TYPE_ICON[parseInt(index)];
        },
        textActionType(index) {
            return ACTION_TYPE_DEGREE[parseInt(index)];
        },
        itemStatusClick(data) {
            const oldStatus = data.status;
            this.$emit('operate', 'status', !oldStatus, data);
        },
        editItem(data) {
            let currentUrl = `/tp/sensitiveWords/page?id=${data.id}`
            if(this.clientSideFlag === 1) {
                let currentType = 1;
                if(this.currentTab === "staff") {
                        currentType = utils.getCurrentType('staffSensitiveWords') ;
                } else {
                    currentType = utils.getCurrentType('clientSensitiveWords');
                }
                currentUrl = `${currentUrl}&currentType=${currentType}`;
            }
            window.location.href = currentUrl;
        },
        calldelItemDialog(data) {
            this.delDialogShow = true;
            this.delId = data.id;
        },
        delItem() {
            // ("delete",id)
            this.$emit('operate', 'delete', this.delId);
        },
        downloadHover(data) {
            this.downloadHoverId = data.id;
        },
        downloadUnhover() {
            this.downloadHoverId = -1;
        },
        downloadIconName(data) {
            if (data.hasRecord == 1 && data.id == this.downloadHoverId) return 'derived_hover';
            return 'derived';
        },
        download(data) {
            if (data.hasRecord != 1) return;
            let { origin } = window.location;
            if (!origin) {
                origin = `${window.location.protocol}//${window.location.hostname}${
                    window.location.port ? `:${window.location.port}` : ''
                }`;
            }
            const type = this.currentTab === 'client' ? '&side=2' : '';
            document.location = `${envDomain.gateway}/tp/sensitiveWords/exportSensitiveWordRecord?wordSetId=${data.id}${type}`;
        },
        onTagClickHandler(item){
            this.$emit('onTagClick', item);
        }
    }
};
</script>

<style lang="less">
@import '~@/common/common.less';

.rule-list {
    margin-top: 15px;

    .v-table__table {
        table-layout: auto;
        .name-column {
            min-width: 137px;
            // max-width: 166px;
        }
        .monitor-types-column {
            min-width: 85px;
            // max-width: 132px;
        }
        .action-type-column {
            min-width: 120px;
            // max-width: 150px;
        }
        .switch-on-column {
            min-width: 45px;
            // max-width: 91px;
        }
        .action-column {
            padding-right: 0px;
            min-width: 82px;
            // max-width: 102px;
        }
    }

    tr {
        cursor: pointer;
    }

    &__action {
        color: #a8abb3;

        .v-icon {
            margin: 0 2px;

            &:hover {
                color: #1e2330;
            }
        }

        .action-btn {
           &:not(:last-child) {
                margin-right: 5px;
           }
        }

        .action-nothing-download {
            cursor: auto;
            opacity: 0.38;
            &:hover {
                color: #a8abb3;
            }
        }
    }

    &__pagination {
        padding: 10px 10px 8px 22px;
    }
}
</style>
